import { cva } from '@/styled-system/css';

export const filterChipWithMenuRootRecipe = cva({
  base: {
    'appearance': 'none',
    'maxWidth': '100%',
    'width': 'auto',
    'position': 'relative',
    'display': 'inline-flex',
    'alignItems': 'center',
    'boxShadow': {
      base: 'inset 0 0 0 {borderWidths.default} var(--shadow-color)',
      _focusWithin: 'inset 0 0 0 {borderWidths.default} var(--shadow-color), {shadows.focus}',
    },
    'boxShadowColor': { base: 'border.action.neutral.default' },
    'borderRadius': 'shape.capsule',
    'paddingInlineStart': 'Chip.padding.horz',
    'paddingBlock': 'Chip.padding.vert',
    'backgroundColor': { base: 'bg.action.neutral.default' },
    'transition': {
      _motionReduce: 'none',
      _motionSafe: 'box-shadow 200ms ease, background-color 200ms ease',
    },
    '&:has(svg + select)': {
      '& [data-c11n-component="FilterChipWithMenu.Select"]': {
        paddingInlineStart: 'calc({spacing.tighter} + {sizes.icon.sm})',
      },
    },
  },
  variants: {
    elevated: {
      true: {},
      false: {},
    },
    disabled: {
      true: {
        cursor: 'default',
        opacity: 'disabled',
      },
      false: {
        cursor: 'pointer',
        backgroundColor: {
          _hover: 'bg.action.neutral.hover',
          _active: 'bg.action.neutral.pressed',
        },
        boxShadowColor: {
          _hover: 'border.action.neutral.hover',
          _active: 'border.action.neutral.pressed',
        },
      },
    },
    isToggledOn: {
      true: {
        boxShadow: {
          base: 'inset 0 0 0 {borderWidths.selected} var(--shadow-color)',
          _focusWithin: 'inset 0 0 0 {borderWidths.selected} var(--shadow-color), {shadows.focus}',
        },
      },
      false: {},
    },
  },
  compoundVariants: [
    {
      disabled: false,
      elevated: true,
      css: {
        backgroundColor: {
          _hover: 'Chip.bg.elevated.hover',
          _active: 'Chip.bg.elevated.pressed',
        },
      },
    },
    {
      disabled: false,
      isToggledOn: true,
      css: {
        backgroundColor: {
          base: 'bg.action.soft.selected.default',
          _hover: 'bg.action.soft.selected.hover',
          _active: 'bg.action.soft.selected.pressed',
        },
        boxShadowColor: {
          base: 'border.action.hero.selected.default',
          _hover: 'Chip.border.selectedHover',
          _active: 'Chip.border.selectedPressed',
        },
      },
    },
    {
      disabled: true,
      isToggledOn: true,
      css: {
        backgroundColor: { base: 'bg.action.soft.selected.default' },
        boxShadowColor: { base: 'border.action.hero.selected.default' },
      },
    },
    {
      elevated: true,
      disabled: false,
      isToggledOn: false,
      css: {
        boxShadow: {
          base: 'inset 0 0 0 {borderWidths.default} var(--shadow-color), {shadows.sm}',
          _hover: {
            base: 'inset 0 0 0 {borderWidths.default} var(--shadow-color), {shadows.Chip.elevated.hover}',
            _focusWithin:
              'inset 0 0 0 {borderWidths.default} var(--shadow-color), {shadows.Chip.elevated.hover}, {shadows.focus}',
          },
          _active: 'inset 0 0 0 {borderWidths.default} var(--shadow-color), {shadows.none}',
          _focusWithin: 'inset 0 0 0 {borderWidths.default} var(--shadow-color), {shadows.focus}',
        },
      },
    },
    {
      elevated: true,
      disabled: false,
      isToggledOn: true,
      css: {
        boxShadow: {
          base: 'inset 0 0 0 {borderWidths.selected} var(--shadow-color), {shadows.sm}',
          _hover: {
            base: 'inset 0 0 0 {borderWidths.selected} var(--shadow-color), {shadows.Chip.elevated.hover}',
            _focusWithin:
              'inset 0 0 0 {borderWidths.selected} var(--shadow-color), {shadows.Chip.elevated.hover}, {shadows.focus}',
          },
          _active: 'inset 0 0 0 {borderWidths.selected} var(--shadow-color), {shadows.none}',
          _focusWithin: 'inset 0 0 0 {borderWidths.selected} var(--shadow-color), {shadows.focus}',
        },
      },
    },
  ],
});
